import { requestUserPasswordResetSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext.js';
import { useState } from 'react';

const EmailForPasswordResetForm = () => {
  const { lang } = useLanguage(translations);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const { sendPasswordResetEmail } = useAuth();

  const handleSubmit = async ({ email }) => await sendPasswordResetEmail(email);
  const onFinish = () => setResetEmailSent(true);

  return (
    <>
      <h1>{lang('forgotPasswordTitle')}</h1>
      {!resetEmailSent ? (
        <ValidatedForm
          key="userEmailForPasswordReset"
          schema={requestUserPasswordResetSchema}
          handleSubmit={handleSubmit}
          onFinish={onFinish}
        >
          <FormInput name="email" type="email" />
          <FormSubmit>{lang('sendResetEmailButtonLabel')}</FormSubmit>
        </ValidatedForm>
      ) : (
        <p>{lang('resetPasswordEmailSent')}</p>
      )}
    </>
  );
};

export default EmailForPasswordResetForm;
